"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.find = exports.register = exports.EDiveHeroSubtype = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var diveSlashEffect_1 = require("@dive/effects/diveSlashEffect");
var diveEnums_1 = require("@dive/enums/diveEnums");
var imports_1 = require("@lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var diveCrew_weaponData_sidecar_1 = require("./diveCrew_weaponData-sidecar");
// TODO: also for heroes??
// export type TDiveEnemyType = '' | 'default' | 'slime' | 'goblin-warrior' | 'rat'
var EDiveHeroSubtype;
(function (EDiveHeroSubtype) {
    // TODO: use data pattern?
    EDiveHeroSubtype[EDiveHeroSubtype["None"] = 0] = "None";
    EDiveHeroSubtype[EDiveHeroSubtype["Default"] = 1] = "Default";
    EDiveHeroSubtype[EDiveHeroSubtype["Peasant"] = 2] = "Peasant";
    EDiveHeroSubtype[EDiveHeroSubtype["Soldier"] = 3] = "Soldier";
    EDiveHeroSubtype[EDiveHeroSubtype["Archer"] = 4] = "Archer";
    EDiveHeroSubtype[EDiveHeroSubtype["Wizard"] = 5] = "Wizard";
    EDiveHeroSubtype[EDiveHeroSubtype["Gunslinger"] = 6] = "Gunslinger";
})(EDiveHeroSubtype = exports.EDiveHeroSubtype || (exports.EDiveHeroSubtype = {}));
var _default = {
    type: EDiveHeroSubtype.Default,
    name: 'Default',
    frames: {
        idle: sprites_sidecar_1.sprites.diveEffectsCloud3,
        dead: sprites_sidecar_1.sprites.diveEffectsCloud3,
        attackR: sprites_sidecar_1.sprites.diveEffectsCloud3,
    },
    bloodTint: diveColors_1.diveColors.red,
    weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({}),
    renderShadow: 1,
};
var _dataList = [];
function register(data) {
    var d = Object.assign({}, _default, data);
    _dataList.push(d);
    return d;
}
exports.register = register;
function find(type) {
    return imports_1.l.find(_dataList, function (c) { return c.type === type; });
}
exports.find = find;
// export function tryFindByCode(code: string) {
//   return l.find(_dataList, (c) => code.startsWith(c.code)) || null
// }
// TODO: add weapon data
function registerAll() {
    register({
        type: EDiveHeroSubtype.None,
        // frames: [sprites.diveHeroes3WeeMonsPeasantIdleR1Png[0]],
        name: 'Null',
    });
    // TODO: redo with new frames
    register({
        type: EDiveHeroSubtype.Peasant,
        name: 'Peasant',
        // frames: [
        //   sprites.diveHeroes3WeeMonsPeasantIdleR1Png[0],
        //   sprites.diveHeroes3WeeMonsPeasantIdleR2Png[0],
        //   sprites.diveHeroes3WeeMonsPeasantDeadPng[0],
        // ],
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantIdleR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes3WeeMonsPeasantAtkR2Png[0],
            ],
        },
        weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 5,
            reloadTime: 4,
            preAttack1Time: 4,
            preAttack2Time: 0,
            postAttackTime: 4,
            maxDistance: 1.5,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.Slash,
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash,
            bulletFrame: 'none',
        }),
    });
    register({
        type: EDiveHeroSubtype.Soldier,
        name: 'Soldier',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterIdleR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterAtkR2Png[0],
            ],
        },
        weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 25,
            reloadTime: 5,
            preAttack1Time: 4,
            preAttack2Time: 0,
            postAttackTime: 4,
            maxDistance: 1.5,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.MeleeSlash,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.Slash,
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Slash,
            bulletFrame: 'none',
            physicalBlockChance: 0.85,
        }),
    });
    register({
        type: EDiveHeroSubtype.Archer,
        name: 'Archer',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherIdleR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherAtkR2Png[0],
            ],
        },
        weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 25,
            reloadTime: 10,
            preAttack1Time: 6,
            preAttack2Time: 6,
            postAttackTime: 6,
            maxDistance: 5,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.Arrow,
            bulletTracking: diveEnums_1.EDiveBulletTracking.Crew,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.ArrowHit,
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Pierce,
            bulletFrame: 'arrow',
        }),
    });
    register({
        type: EDiveHeroSubtype.Wizard,
        name: 'Wizard',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageIdleR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR2Png[0],
            ],
        },
        weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 25,
            reloadTime: 10,
            preAttack1Time: 6,
            preAttack2Time: 0,
            postAttackTime: 6,
            maxDistance: 6,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.Fireball,
            bulletTracking: diveEnums_1.EDiveBulletTracking.Crew,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.FireExplosion,
            bulletFrame: 'fireball',
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Magic,
        }),
    });
    register({
        type: EDiveHeroSubtype.Gunslinger,
        name: 'Gunslinger',
        frames: {
            idle: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageIdleR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageIdleR2Png[0],
            ],
            dead: [sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageDeadPng[0]],
            attackR: [
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR1Png[0],
                sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR2Png[0],
            ],
        },
        weaponData: diveCrew_weaponData_sidecar_1.diveCrew_weaponData.createData({
            damage: 25,
            reloadTime: 10,
            preAttack1Time: 6,
            preAttack2Time: 0,
            postAttackTime: 6,
            maxDistance: 6,
            speed: 300,
            color: voyageColors_sidecar_1.voyageColors.red,
            type: diveEnums_1.EMessageBulletTeamType.Crew,
            bulletType: diveEnums_1.EDiveBulletSubtype.Bullet,
            bulletTracking: diveEnums_1.EDiveBulletTracking.Crew,
            hitEffect: diveSlashEffect_1.EDiveSlashEffect.FireExplosion,
            bulletFrame: 'bullet',
            damageType: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Pierce,
        }),
    });
}
exports.registerAll = registerAll;
